// extracted by mini-css-extract-plugin
export default {"Outer":"List_Outer__0zlx+","List":"List_List__DOf-4"};